<ps-ui-modal class="modal-dialog-centered">
  <div psUiModalTitle>
    <i
      class="fa fa-exclamation-circle fa-4x text-center"
      aria-hidden="true"
    ></i>
    <br />
    <h4>Are you want to sure to clear PSIDs?</h4>
  </div>
  <ps-ui-modal-footer class="padFooter">
    <button
      type="button"
      class="width50"
      psUiButton
      color="secondary"
      size="large"
      (click)="close()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="width50"
      psUiButton
      size="large"
      (click)="clear()"
    >
      Clear PSIDs
    </button>
  </ps-ui-modal-footer>
</ps-ui-modal>
